var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"aria-label":_vm.name + '-icon',"aria-hidden":_vm.ariaHidden}},[_c('use',{attrs:{"xlink:href":("" + _vm.$contextPath + _vm.sprite + "#" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }